export default class ButtonItemType {
  constructor(data) {
    this.id = null;
    this.name = null;
    // Initialize data
    if (data) {
      Object.assign(this, {
        id: data.Id,
        name: data.Name
      });
    }
  }
}



// WEBPACK FOOTER //
// src/entities/case/case-button-items/button-item-type.js